import {Component, OnInit} from '@angular/core';
import {CpProvisionContractAgentBaseComponent} from '../base/cp-provision-contract-agent-base.component';

/**
 * Full view of the Provisionssatz OBC (`uiMode = 'full'`).
 *
 * Shape of `cp-provision-agent-full.component.ts`: inherits the `navigationItems` from
 * {@link CpProvisionContractAgentBaseComponent} and renders exactly ONE shared detail component
 * per active navigation item. It holds no business logic and no form HTML of its own.
 */
@Component({
    selector: 'cp-provision-contract-agent-full',
    templateUrl: './cp-provision-contract-agent-full.component.html',
    styleUrls: ['./cp-provision-contract-agent-full.component.scss'],
    standalone: false
})
export class CpProvisionContractAgentFullComponent extends CpProvisionContractAgentBaseComponent
    implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
